<ct-type-attribute-grid
  [gridSettings]="gridSetting"
  [type]="type"
  [data]="data"
></ct-type-attribute-grid>
